import { Pipe, PipeTransform } from '@angular/core';

/**
 * The return value of this pipe should be used in the innerHTML prop.
 * @example
 * <div [innerHTML]="contentWithNewLines | withLineBreaks"></div>
 */
@Pipe({
	name: 'withLineBreaks',
	standalone: false,
})
export class WithLineBreaksPipe implements PipeTransform {
	transform(value: unknown): string {
		if (typeof value !== 'string') return '';
		return value.trim().replaceAll('\n', '<br/>');
	}
}
